import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Un-guarded group for pages reachable pre-signup and by anonymous visitors:
 * the phone location-proof webform (URL token = auth), and the legal
 * document pages (terms, privacy). Separate from `(auth-pages)`, whose
 * onboarding child bootstraps an anon session.
 */
export const Route = createFileRoute("/(public)")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
